var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{on:{"click":_vm.sortTable}},[_vm._t("default"),(_vm.sortBy == _vm.field.key)?_c('span',{staticClass:"arrow",class:_vm.sortAsc ? 'asc' : 'dsc'}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }